// src/core/carouselScroll.js
export function initCarouselScroll(container) {
  if (!container) return;

  function updateWidth() {
    console.log("Visible width:", container.clientWidth, "Total width:", container.scrollWidth);
  }

  updateWidth();
  window.addEventListener("resize", updateWidth);

  let touchStartX = 0;
  let scrollLeft = 0;

  // Solo manejamos touch
  const handleTouchStart = (e) => {
    touchStartX = e.touches[0].pageX;
    scrollLeft = container.scrollLeft;
  };

  const handleTouchMove = (e) => {
    const x = e.touches[0].pageX;
    const walk = (x - touchStartX) * 1.5;
    container.scrollLeft = scrollLeft - walk;
    e.preventDefault(); // evita scroll vertical del navegador
  };

  container.addEventListener("touchstart", handleTouchStart, { passive: false });
  container.addEventListener("touchmove", handleTouchMove, { passive: false });

  return () => {
    window.removeEventListener("resize", updateWidth);
    container.removeEventListener("touchstart", handleTouchStart);
    container.removeEventListener("touchmove", handleTouchMove);
  };
}
